import { RouteRecordRaw } from "vue-router";
import { NotFound } from "./app/not-found/not-found";
import { Home } from "./app/home/home";
import { News } from "./app/news/news";
import { SingleNews } from "./app/single-news/singleNews";
import { Healthcare } from "./app/healthcare/healthcare";

export const routes: RouteRecordRaw[] = [
	{
		path: '/',
		component: Home,
	},
	{
		path: "/news",
		component: News,
	},
	{
		path: "/healthcare-social-media",
		component: Healthcare,
	},
	{
		path: "/:slug",
		component: SingleNews,
	},
	{
		path: "/:pathMatch(.*)*",
		redirect: '/404',
	},
	{
		path: "/404",
		component: NotFound,
	},
];
